'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cultures = {
	"default": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"ar-AE": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"ar-KW": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"ar-QA": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"ar-SA": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"cs-CZ": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "3"
	},
	"de-DE": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "2"
	},
	"da-DK": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "2"
	},
	"en-AU": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"en-GB": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"en-US": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"es-AR": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"es-CL": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"es-ES": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "2"
	},
	"es-MX": {
		currencyFormatting: {
			"default": "1",
			RUB: "2"
		},
		numberFormat: "1"
	},
	"fa-IR": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"fr-FR": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "3"
	},
	"he-IL": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"hi-IN": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"it-IT": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "2"
	},
	"ja-JP": {
		currencyFormatting: {
			"default": "2"
		},
		numberFormat: "1"
	},
	"ko-KR": {
		currencyFormatting: {
			"default": "2"
		},
		numberFormat: "1"
	},
	"ms-MY": {
		currencyFormatting: {
			"default": "2"
		},
		numberFormat: "1"
	},
	"nl-NL": {
		currencyFormatting: {
			"default": "2"
		},
		numberFormat: "2"
	},
	"pl-PL": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "3"
	},
	"ru-RU": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "3"
	},
	"sv-SE": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "2"
	},
	"tr-TR": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "1"
	},
	"uk-UA": {
		currencyFormatting: {
			"default": "4"
		},
		numberFormat: "4"
	}
};
var currencyFormats = {
	"1": {
		negative: "-{C}{N}",
		positive: "{C}{N}"
	},
	"2": {
		negative: "-{C} {N}",
		positive: "{C} {N}"
	},
	"3": {
		negative: "-{N}{C}",
		positive: "{N}{C}"
	},
	"4": {
		negative: "-{N} {C}",
		positive: "{N} {C}"
	}
};
var currencySymbols = {
	AED: {
		"default": "AED"
	},
	AUD: {
		"default": "$"
	},
	CAD: {
		"default": "C$"
	},
	CHF: {
		"default": "CHF"
	},
	CNY: {
		"default": "¥"
	},
	CZK: {
		"default": "Kč"
	},
	DKK: {
		"default": "DKK",
		"da-DK": "kr."
	},
	EUR: {
		"default": "€"
	},
	GBP: {
		"default": "£"
	},
	HKD: {
		"default": "HKD$"
	},
	ILS: {
		"default": "ILS"
	},
	INR: {
		"default": "INR"
	},
	IRR: {
		"default": "IRR"
	},
	JPY: {
		"default": "JPY"
	},
	KRW: {
		"default": "KRW"
	},
	KWD: {
		"default": "KWD"
	},
	MYR: {
		"default": "RM"
	},
	NOK: {
		"default": "NOK"
	},
	NZD: {
		"default": "NZD$"
	},
	PLN: {
		"default": "PLN",
		"pl-PL": "zł."
	},
	QAR: {
		"default": "QAR"
	},
	RUB: {
		"default": "руб."
	},
	SAR: {
		"default": "SAR"
	},
	SEK: {
		"default": "SEK"
	},
	SGD: {
		"default": "SGD$"
	},
	TRY: {
		"default": "TRY"
	},
	TWD: {
		"default": "NT$"
	},
	UAH: {
		"default": "UAH"
	},
	USD: {
		"default": "$"
	}
};
var numberFormats = {
	"1": "###,###.##",
	"2": "###.###,##",
	"3": "### ###,##",
	"4": "### ###.##"
};
var config = {
	cultures: cultures,
	currencyFormats: currencyFormats,
	currencySymbols: currencySymbols,
	numberFormats: numberFormats
};

var numberFormatPattern = new RegExp(/(#+)([^#])(#+)([^#]|$)(#+|$)/g);
var negativeSign = "-";

var getNumberFormatData = function getNumberFormatData(numberFormat) {
  var matches = numberFormat.split(numberFormatPattern).filter(function (p) {
    return p !== "";
  });

  if (matches.length < 3) {
    return undefined;
  }

  return {
    digitGroupingLength: matches[0].length,
    digitGroupingSymbol: matches[1],
    digitsBeforeDecimal: matches[2].length,
    decimalSeparator: matches[3],
    decimalPlaces: matches[4] ? matches[4].length : 0
  };
};

var reverseString = function reverseString(input) {
  return input.split("").reverse().join("");
};

var buildFormattedValue = function buildFormattedValue(valueAsNumber, discardDecimals, _ref) {
  var digitGroupingSymbol = _ref.digitGroupingSymbol,
      digitGroupingLength = _ref.digitGroupingLength,
      digitsBeforeDecimal = _ref.digitsBeforeDecimal,
      decimalSeparator = _ref.decimalSeparator,
      decimalPlaces = _ref.decimalPlaces;
  var hasDecimals = !!decimalSeparator && !discardDecimals;
  var valueAsString = discardDecimals ? Math.abs(valueAsNumber).toString() : Math.abs(valueAsNumber).toFixed(decimalPlaces);
  var reversedValue = reverseString(valueAsString).split("");
  var digitGroupingIndexStart = hasDecimals ? decimalPlaces + 1 + digitsBeforeDecimal : digitsBeforeDecimal; // eslint-disable-next-line complexity

  var formatted = reversedValue.reduce(function (accumulator, _char, i) {
    if (!hasDecimals && i === digitsBeforeDecimal) {
      return "".concat(_char).concat(digitGroupingSymbol).concat(accumulator);
    }

    if (hasDecimals && i === decimalPlaces) {
      return "".concat(decimalSeparator).concat(accumulator);
    }

    var groupingStarted = i >= digitGroupingIndexStart;
    var isGroupingIndex = (i - digitGroupingIndexStart) % digitGroupingLength === 0;

    if (groupingStarted && isGroupingIndex) {
      return "".concat(_char).concat(digitGroupingSymbol).concat(accumulator);
    }

    return "".concat(_char).concat(accumulator);
  });

  if (valueAsNumber < 0) {
    return "".concat(negativeSign).concat(formatted);
  }

  return formatted;
};

function isInteger(valueAsNumber) {
  return Math.round(valueAsNumber) === valueAsNumber;
}

var throwIfDiscardingDecimalsFromNonInteger = function throwIfDiscardingDecimalsFromNonInteger(valueAsNumber, formatAsInteger) {
  if (formatAsInteger && !isInteger(valueAsNumber)) {
    throw new Error("Value must be an integer when formatAsInteger is set to true, else numeric precision will be lost");
  }
};

var formatValue = function formatValue(value, cultureCode, formatAsInteger) {
  var valueAsNumber = Number(value);

  if (isNaN(valueAsNumber) || !isFinite(valueAsNumber)) {
    return value;
  }

  throwIfDiscardingDecimalsFromNonInteger(valueAsNumber, formatAsInteger);
  var culture = config.cultures[cultureCode] || config.cultures["default"];
  var numberFormat = config.numberFormats[culture.numberFormat];
  var numberFormatData = getNumberFormatData(numberFormat);

  if (!numberFormatData) {
    return value;
  }

  return buildFormattedValue(valueAsNumber, formatAsInteger, numberFormatData);
};

var valuePlaceholder = "{N}";
var currencySymbolPlaceholder = "{C}";
var getCurrencySymbol = function getCurrencySymbol(currencyCode, cultureCode) {
  var symbolDictionary = config.currencySymbols[currencyCode];

  if (!symbolDictionary) {
    return "";
  }

  var currencySymbol = symbolDictionary[cultureCode] || symbolDictionary["default"];
  return currencySymbol;
};
var formatPrice = function formatPrice(value, cultureCode, currencyCode, formatAsInteger) {
  var asNumber = Number(value);

  if (!numberIsValid(asNumber)) {
    return value;
  }

  var currencySymbol = getCurrencySymbol(currencyCode, cultureCode);
  var currencyFormat = getCurrencyFormat(cultureCode, currencyCode);

  if (!currencySymbol) {
    return value;
  }

  var formattedValue = formatValue(Math.abs(asNumber), cultureCode, formatAsInteger);
  var signedFormat = asNumber < 0 ? currencyFormat.negative : currencyFormat.positive;
  var formattedCurrency = signedFormat.replace(currencySymbolPlaceholder, currencySymbol);
  formattedCurrency = formattedCurrency.replace(valuePlaceholder, formattedValue);
  return formattedCurrency;
};

var numberIsValid = function numberIsValid(value) {
  return !isNaN(value) && isFinite(value);
};

var getCurrencyFormat = function getCurrencyFormat(cultureCode, currencyCode) {
  var cultureData = config.cultures[cultureCode] || config.cultures["default"];
  var currencyFormatType = cultureData.currencyFormatting[currencyCode] || cultureData.currencyFormatting["default"];
  return config.currencyFormats[currencyFormatType];
};

exports.formatPrice = formatPrice;
exports.formatValue = formatValue;
exports.getCurrencySymbol = getCurrencySymbol;
